import { render, staticRenderFns } from "./ProductCardNotificationLine.vue?vue&type=template&id=f56d0b88"
import script from "./ProductCardNotificationLine.vue?vue&type=script&lang=js"
export * from "./ProductCardNotificationLine.vue?vue&type=script&lang=js"
import style0 from "./ProductCardNotificationLine.vue?vue&type=style&index=0&id=f56d0b88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports